var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "time-select" }, [
    _c("div", { staticClass: "header" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("wp.whenSendMessage")))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "times" },
      [
        _c(
          "div",
          {
            staticClass: "time-box",
            class: { active: _vm.selection === "now" },
            on: {
              click: function () {
                return _vm.changeSelection("now")
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("wp.instantlyRightNow")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("a-alert", {
          attrs: {
            message: _vm.getInfoMessage(),
            type: "info",
            "show-icon": "",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }